import React, { useState } from 'react';
import { reportMessage } from '../../services/api';

// States: idle → confirm → loading → done | error
// The child clicks the flag icon, writes an optional reason, then submits.
// On error, a retry link is shown.

export default function ReportButton({ sessionId, messageId }) {
  const [state,  setState]  = useState('idle');
  const [reason, setReason] = useState('');

  const submit = async () => {
    setState('loading');
    try {
      await reportMessage(sessionId, messageId, reason || undefined);
      setState('done');
    } catch {
      setState('error');
    }
  };

  if (state === 'done') {
    return (
      <span style={{ fontSize: 12, color: '#059669' }}>
        Thanks for letting us know. A trusted adult will review this.
      </span>
    );
  }

  if (state === 'error') {
    return (
      <span style={{ fontSize: 12, color: '#dc2626' }}>
        Could not send report.{' '}
        <button
          onClick={() => setState('idle')}
          style={{ background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', fontSize: 'inherit', padding: 0 }}
        >
          Try again
        </button>
      </span>
    );
  }

  if (state === 'confirm' || state === 'loading') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="What felt wrong? (optional)"
          maxLength={500}
          rows={2}
          disabled={state === 'loading'}
          style={{
            fontSize: 13, padding: '6px 8px', borderRadius: 8,
            border: '1px solid #d1d5db', resize: 'none', width: '100%',
          }}
        />
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={submit}
            disabled={state === 'loading'}
            style={{
              fontSize: 13, padding: '6px 16px', borderRadius: 8,
              background: '#dc2626', color: '#fff', border: 'none',
              cursor: state === 'loading' ? 'not-allowed' : 'pointer',
            }}
          >
            {state === 'loading' ? 'Sending…' : 'Send report'}
          </button>
          <button
            onClick={() => setState('idle')}
            disabled={state === 'loading'}
            style={{
              fontSize: 13, padding: '6px 16px', borderRadius: 8,
              background: 'transparent', border: '1px solid #d1d5db',
              cursor: state === 'loading' ? 'not-allowed' : 'pointer',
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  // idle state — show the flag icon button
  return (
    <button
      onClick={() => setState('confirm')}
      title="Report this response"
      aria-label="Report this response as concerning"
      style={{
        background: 'none', border: 'none', cursor: 'pointer',
        fontSize: 12, color: '#9ca3af', padding: '2px 4px',
        lineHeight: 1,
      }}
    >
      ⚑ Report
    </button>
  );
}
